import { Pipe, PipeTransform } from '@angular/core';
import { LocalizedDate } from '@app/core/utilities/date.utilities';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
  transform(value: string | number | Date, format = 'dd MMM yyyy'): string {
    return LocalizedDate(value, format);
  }
}
